{
  "title": "Édition d'un collaborateur",
  "subtitle": "Modifiez les informations du collaborateur.",
  "form": {
    "personalInfo": "Informations personnelles",
    "lastname": "Nom",
    "firstname": "Prénom"
  },
  "placeholders": {
    "lastname": "Nom",
    "firstname": "Prénom"
  },
  "buttons": {
    "validate": "Valider"
  },
  "messages": {
    "success": "Collaborateur mis à jour"
  }
}
